<template>
    <form class="auth-form" autocomplete="off">
        <div class="d-flex justify-content-between align-items-center flex-wrap">
            <div class="col-12 mb-4 text-center">
                <h5 class="text-white">
                    {{ $t('auth.emailSend.passwordReset') }}
                </h5>
            </div>
            <div class="col-12 mb-2">
                <label class="mb-2" for="new_password">
                    <i class="fa-solid fa-key"></i>
                </label>
                <input v-model="newPassword" @keyup="validatePassword" name="newPassword"  type="password" class="form-control" :placeholder="$t('accounts.label.newPassword')" :class="errors.newPassword ? 'is_invalid' : '' " autocomplete="off">
                <small v-if="errors.newPassword" class="is_invalid">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    {{ errors.newPassword }}
                </small>
            </div>
            <div class="col-12 mb-4">
                <input v-model="repeat_newPassword" @keyup="validateRepPassword" name="repeat_newPassword" type="password" class="form-control" :placeholder="$t('auth.repPassword')" :class="errors.repeat_newPassword ? 'is_invalid' : ''" autocomplete="off">
                <small v-if="errors.repeat_newPassword" class="is_invalid">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    {{ errors.repeat_newPassword }}
                </small>
            </div>
            <div class="col-12 d-flex justify-content-center">
                <span @click="changePassword" class="btn btn-success w-100">
                    <i class="fas fa-save me-2"></i>
                    {{ $t('accounts.button.save') }}
                </span>
            </div>
        </div>
    </form>
    <transition name="fade-modal">
        <modal v-if="successModal" @close="successModal = false">
            <template v-slot:header>
                <div class="modal-header bg-success border-0 rounded-0 text-light">
                    <div class="d-flex align-items-center">
                        <i class="fas fa-key me-2"></i>
                        <h5 class="modal-title">
                            {{ $t('modal.successModal.header.passwordEdited') }}
                        </h5>
                    </div>
                </div>
            </template>
        </modal>
    </transition>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import Modal from './Modal.vue';
export default {
    name: 'ChangePassword',
    components: {
        Modal
    },
    data() {
        return {
            newPassword: '',
            repeat_newPassword: '',
            errors: {
                newPassword: '',
                repeat_newPassword: ''
            },
            successModal: false
        }
    },
    computed: {
        ...mapGetters(["apiPath"]),
    },
    methods: {
        validatePassword() {
            const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

            if (this.newPassword.length == 0 ) {
                return this.errors.newPassword = this.$t('errors.required')
            } else if (this.newPassword.length < 8) {
                return this.errors.newPassword = this.$t('errors.password.length')
            } else if (!/\d/.test(this.newPassword)) {
                return this.errors.newPassword = this.$t('errors.password.number')
            } else if (!/[A-Z]/.test(this.newPassword)) {
                return this.errors.newPassword = this.$t('errors.password.uppercase')
            } else if (!/[a-z]/.test(this.newPassword)) {
                return this.errors.newPassword = this.$t('errors.password.lowercase')
            } else if (!format.test(this.newPassword)) {
                return this.errors.newPassword = this.$t('errors.password.special')
            } else {
                delete this.errors.newPassword
            }
            this.validateRepPassword();

        },
        validateRepPassword() {

            if (this.repeat_newPassword.length == 0 ) {
                return this.errors.repeat_newPassword = this.$t('errors.required')
            } else if (this.repeat_newPassword != this.newPassword) {
                return this.errors.repeat_newPassword = this.$t('errors.password.match')
            } else {
                delete this.errors.repeat_newPassword
            }

        },
        ...mapMutations(["setAccount"]),
        changePassword() {
            this.$http
                .post(`${this.apiPath}/account/change_password`, {id: this.$route.query.token, currentPassword: null, newPassword: this.newPassword, repeat_newPassword: this.repeat_newPassword}, {
                    headers: {
                        'x-api-key': this.$store.state.config.oms_api.key
                    }
                })
                .then(
                    (res) => {
                        if (res.data.account){
                            this.successModal = true
                            setTimeout(() => {
                                this.successModal = false
                                window.close()
                            }, 1500);
                        }
                    }
                )
                .catch((err) => {
                    this.$store.state.serverModal = true
                    this.$store.state.errServer = err.message
                })
        }
    }
}
</script>

<style lang="scss" scoped>
    .auth-form {
        input{
            border: 1px solid #ced4da;
        }
    }
</style>